import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.app-key-password', {
        url: '/app-key-password',
        component: 'companyManageApplicationIntegrationDevelopersAppKeyPassword',
        resolve: {
            credentials,
        },
    });
}

/** @ngInject */
function credentials(credentials$) {
    return credentials$.get();
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/app-key-password/app-key-password.state.js